import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "10",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--_dn-icon_color)",
      d: "M2.268 2.355c-.89 1.139-1.017 2.287-.756 3.09.987-.803 2.358-.635 3.194.165.843.809.916 2.23.377 3.15A2.46 2.46 0 0 1 2.948 10C.928 10 0 8.173 0 6.124q0-1.996.992-3.576Q1.985.968 3.987 0l.36.717q-1.21.524-2.08 1.638m6.576 0c-.889 1.139-1.017 2.287-.756 3.09q.662-.522 1.436-.523c1.36 0 2.476.929 2.476 2.54C12 8.941 10.892 10 9.524 10c-2.019 0-2.948-1.827-2.948-3.876q0-1.996.993-3.576Q8.56.968 10.564 0l.359.717q-1.21.524-2.079 1.638"
    }, null, -1)
  ]))]))
}
export default { render: render }